import { gamification } from "@circle-react/helpers/urlHelpers/internalApi/gamification";
import { accessRegistry } from "./accessRegistry";
import { accountAuthentication } from "./accountAuthentication";
import { accountPaymentProcessors } from "./accountPaymentProcessors";
import { AccountSubscriptions } from "./accountSubscriptions";
import { admin } from "./admin";
import { aiWorkflowsBillingHistory } from "./aiWorkflowsBillingHistory";
import { analytics } from "./analytics";
import { apiAnalytics } from "./apiAnalytics";
import { apiTokens } from "./apiTokens";
import { asyncTasks } from "./asyncTasks";
import { authProviders } from "./authProviders";
import { bookmarks } from "./bookmarks";
import { brandedAppsBuilderUI } from "./brandedAppsBuilderUI";
import { broadcasts } from "./broadcasts";
import { chatPreferences } from "./chatPreferences";
import { chatRoomMessages } from "./chatRoomMessages";
import { chatRoomParticipants } from "./chatRoomParticipants";
import { chatRooms } from "./chatRooms";
import { chatSpaces } from "./chatSpaces";
import { chatThreads } from "./chatThreads";
import { comments } from "./comments";
import { communities } from "./communities";
import { communityAiAgentProfile } from "./communityAiAgentProfile";
import { communityBot } from "./communityBot";
import { communityInbox } from "./communityInbox";
import { communityLead } from "./communityLead";
import { communityMember } from "./communityMember";
import { communityMemberBulkInvitations } from "./communityMemberBulkInvitations";
import { communityMemberCharge } from "./communityMemberCharge";
import { communityMemberPaymentMethod } from "./communityMemberPaymentMethod";
import { communityMemberPaymentProcessor } from "./communityMemberPaymentProcessor";
import { communityMemberSubscription } from "./communityMemberSubscription";
import { communityMemberSubscriptionPriceChanges } from "./communityMemberSubscriptionPriceChanges";
import { communityMembers } from "./communityMembers";
import { communityPlanAddons } from "./communityPlanAddons";
import { contactMarketingEmailPreferences } from "./contactMarketingEmailPreferences";
import { contacts } from "./contacts";
import { connectSettings } from "./connectSettings";
import { copilot } from "./copilot";
import { currentContact } from "./currentContact";
import { corsAllowedOrigins } from "./corsAllowedOrigins";
import { courseTopics } from "./courseTopics";
import { courses } from "./courses";
import { customDomain } from "./customDomain";
import { emailHub } from "./emailHub";
import { emailHubStatus } from "./emailHubStatus";
import { emailHubSubscription } from "./emailHubSubscription";
import { emailValidations } from "./emailValidations";
import { embeds } from "./embeds";
import { entityPreviews } from "./entityPreviews";
import { eventAttendees } from "./eventAttendees";
import { eventLiveStreams } from "./eventLiveStreams";
import { events } from "./events";
import { flaggedContent } from "./flaggedContent";
import { forms } from "./forms";
import { helpWidget } from "./helpWidget";
import { homePagePosts } from "./homePagePosts";
import { imagePosts } from "./imagePosts";
import { importContacts } from "./importContacts";
import { invitationLinks } from "./invitationLinks";
import { landingPageSettings } from "./landingPageSettings";
import { layoutPartials } from "./layoutPartials";
import { liveStreams } from "./liveStreams";
import { manageMembers } from "./manageMembers";
import { marketingEmailAddressSettings } from "./marketingEmailAddressSettings";
import { marketingEmailPreferences } from "./marketingEmailPreferences";
import { marketingEmailTemplates } from "./marketingEmailTemplates";
import { masquerading } from "./masquerading";
import { mediaSettings } from "./mediaSettings";
import { mediaTranscodings } from "./mediaTranscodings";
import { mediaTranscripts } from "./mediaTranscripts";
import { memberActivityScore } from "./memberActivityScore";
import { memberTags } from "./memberTags";
import { moderationSettings } from "./moderationSettings";
import { nextPlanWithFeature } from "./nextPlanWithFeature";
import { notificationPreferences } from "./notificationPreferences";
import { notifications } from "./notifications";
import { oneSchemaConfiguration } from "./oneSchemaConfiguration";
import { paywallCoupons } from "./paywallCoupons";
import { paywallGroup } from "./paywallGroup";
import { paywalls } from "./paywalls";
import { paywallCheckout } from "./paywalls/checkout";
import { paywallsAffiliatesSettings } from "./paywallsAffiliatesSettings";
import { pinnedChatRoom } from "./pinnedChatRoom";
import { planFeatureFlags } from "./planFeatureFlags";
import { planTrials } from "./planTrials";
import { plans } from "./plans";
import { polls } from "./polls";
import { postDetails } from "./postDetails";
import { postFollowers } from "./postFollowers";
import { posts } from "./posts";
import { profile } from "./profile";
import { profileFields } from "./profileFields";
import { punditUser } from "./punditUser";
import { pushNotifications } from "./pushNotifications";
import { quizAttempts } from "./quizAttempts";
import { reactions } from "./reactions";
import { recurringEvents } from "./recurringEvents";
import { richTextFields } from "./richTextFields";
import { scheduleDowngrades } from "./scheduleDowngrades";
import { scheduledEmails } from "./scheduledEmails";
import { search, searchV2 } from "./search";
import { segments } from "./segments";
import { settings } from "./settings";
import { sidebarNotifications } from "./sidebarNotifications";
import { site } from "./site";
import { spaceGroups } from "./spaceGroups";
import { spaceMembers } from "./spaceMembers";
import { spaces } from "./spaces";
import { submissions } from "./submissions";
import { supportWidget } from "./supportWidget";
import { supportedCurrencies } from "./supportedCurrencies";
import { systemMarketingEmailTemplates } from "./systemMarketingEmailTemplates";
import { topics } from "./topics";
import { upcomingEvents } from "./upcomingEvents";
import { voiceMessages } from "./voiceMessages";
import { workflowsUpcomingEvents } from "./workflowsUpcomingEvents";
import { blockedMembers } from "./blockedMembers";

export const internalApi = {
  admin,
  aiWorkflowsBillingHistory,
  analytics,
  asyncTasks,
  apiTokens,
  AccountSubscriptions,
  bookmarks,
  chatRoomMessages,
  chatRoomParticipants,
  chatRooms,
  chatSpaces,
  chatPreferences,
  comments,
  communities,
  communityAiAgentProfile,
  communityLead,
  contactMarketingEmailPreferences,
  communityMember,
  communityMemberCharge,
  communityMemberPaymentMethod,
  communityMemberPaymentProcessor,
  communityMembers,
  communityMemberSubscription,
  communityMemberSubscriptionPriceChanges,
  communityPlanAddons,
  connectSettings,
  customDomain,
  accountAuthentication,
  authProviders,
  courses,
  quizAttempts,
  embeds,
  entityPreviews,
  eventAttendees,
  eventLiveStreams,
  events,
  flaggedContent,
  forms,
  helpWidget,
  copilot,
  gamification,
  homePagePosts,
  imagePosts,
  invitationLinks,
  layoutPartials,
  liveStreams,
  manageMembers,
  emailHubStatus,
  emailHub,
  memberTags,
  moderationSettings,
  notificationPreferences,
  notifications,
  paywallCheckout,
  paywallCoupons,
  paywallGroup,
  paywalls,
  paywallsAffiliatesSettings,
  planFeatureFlags,
  planTrials,
  polls,
  postDetails,
  postFollowers,
  posts,
  profile,
  contacts,
  currentContact,
  profileFields,
  punditUser,
  reactions,
  recurringEvents,
  richTextFields,
  search,
  searchV2,
  segments,
  settings,
  sidebarNotifications,
  site,
  spaceGroups,
  spaceMembers,
  spaces,
  submissions,
  supportedCurrencies,
  supportWidget,
  upcomingEvents,
  voiceMessages,
  workflowsUpcomingEvents,
  chatThreads,
  plans,
  scheduleDowngrades,
  emailHubSubscription,
  memberActivityScore,
  mediaSettings,
  mediaTranscodings,
  mediaTranscripts,
  accountPaymentProcessors,
  landingPageSettings,
  masquerading,
  topics,
  courseTopics,
  communityMemberBulkInvitations,
  importContacts,
  scheduledEmails,
  broadcasts,
  pushNotifications,
  marketingEmailPreferences,
  marketingEmailAddressSettings,
  pinnedChatRoom,
  corsAllowedOrigins,
  apiAnalytics,
  communityInbox,
  communityBot,
  accessRegistry,
  nextPlanWithFeature,
  brandedAppsBuilderUI,
  oneSchemaConfiguration,
  emailValidations,
  marketingEmailTemplates,
  systemMarketingEmailTemplates,
  blockedMembers,
};
